class HeroBanner extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector(".carousel-inner");
    this.banners = this.querySelectorAll(".banner");
    this.controls = this.querySelectorAll(".banner-control");

    this.onControlClick = this.handleControlClick.bind(this);
    this.nextBanner = this.handleNextBanner.bind(this);

    this.carouselHeight = 420;
    this.banners.forEach((banner) => {
      if (banner.clientHeight > this.carouselHeight) {
        this.carouselHeight = banner.clientHeight;
      }
    });

    this.carousel.style.height = `${this.carouselHeight}px`;

    this.banners.forEach((banner) => {
      banner.style.height = `${this.carouselHeight}px`;
    });

    // controls
    this.controls.forEach((control) => {
      control.addEventListener("click", this.onControlClick);
    });

    this.currentBannerIndex = 0;
    if (this.banners.length > 1) {
      setInterval(this.nextBanner, 5500);
    }
  }

  handleNextBanner() {
    if (this.currentBannerIndex < this.banners.length - 1) {
      this.currentBannerIndex++;
    } else {
      this.currentBannerIndex = 0;
    }
    this.controls[this.currentBannerIndex].click();
  }

  hideBanners() {
    this.banners.forEach((banner) => {
      banner.classList.remove("banner-active");
      banner.classList.add("banner-hidden");
    });
  }

  handleControlClick(evt) {
    const control = evt.target;

    const controlIndex =
      parseInt(control.dataset.control.replace("banner-", "")) - 1;

    const banner = this.querySelector(`#${control.dataset.control}`);

    if (!banner.classList.contains("banner-active")) {
      this.hideBanners();
      banner.classList.add("banner-active");
    } else {
      this.hideBanners();
    }

    this.currentBannerIndex = controlIndex;
  }
}

customElements.define("hero-banner", HeroBanner);
